import {
  ADD_MODULE,
  ADD_COURSE,
  ADD_MODULE_SHOW,
  STEPPER_NEXT,
  ADD_COURSE_RESET,
  ADD_MODULE_RESET,
  PLAY_VIDEO,
  PERCENT_AGE,
  STEPPER_COHORT,
  STEPPER_COURSES,
  JUMP_PAGE,
  COURSEID,
  UPDATE_PREV_TAG_STATE,
  GetFilteredData,
  ClearFilteredData,
  isPodcastView,
  isAssignLearnerStep,
  isSeatingCapacityFull,
  masterCourseID,
  isClonedCourse,
  Nomination_EndDate,
  courseStartDate,
  classroomTimings,
  getPreviousBatchEmployees,
  SET_SELECTED_EMPLOYEES,
  userRoleAccess,
  lmsReqApprove,
  reassignCoordinator,
  superAdminUserName,
  nominatedCourseID,
  iseditClonedCourse,
} from "../constants/AppConstants";

export const addCourse = (data) => {
  return {
    type: ADD_COURSE,
    payload: data,
  };
};

export const addModule = (data) => {
  return {
    type: ADD_MODULE,
    payload: data,
  };
};

export const addCourseReset = (data) => {
  return {
    type: ADD_COURSE_RESET,
    payload: data,
  };
};

export const addModuleReset = (data) => {
  return {
    type: ADD_MODULE_RESET,
    payload: data,
  };
};

export const addModuleShow = (data) => {
  return {
    type: ADD_MODULE_SHOW,
    payload: data,
  };
};

export const nextStepper = (data) => {
  return {
    type: STEPPER_NEXT,
    payload: data,
  };
};

export const nxtStpr = (data) => {
  return {
    type: JUMP_PAGE,
    payload: data,
  };
};

export const addPlayVideo = (data) => {
  return {
    type: PLAY_VIDEO,
    payload: data,
  };
};

export const addPercentage = (data) => {
  return {
    type: PERCENT_AGE,
    payload: data,
  };
};

export const nextStepperCohort = (data) => {
  return {
    type: STEPPER_COHORT,
    payload: data,
  };
};
export const nextStepperCourses = (data) => {
  return {
    type: STEPPER_COURSES,
    payload: data,
  };
};

export const CourseId = (data) => {
  return {
    type: COURSEID,
    payload: data,
  };
};

export const updateTagStateData = (data) => {
  return {
    type: UPDATE_PREV_TAG_STATE,
    payload: data,
  };
};

export const updatePodView = (data) => {
  return {
    type: isPodcastView,
    payload: data,
  };
};

export const viewAssignLearnerStep = (data) => {
  return {
    type: isAssignLearnerStep,
    payload: data,
  };
};

export const SeatingCapacityFull = (data) => {
  return {
    type: isSeatingCapacityFull,
    payload: data,
  };
};

export const MasterCourseID = (data) => {
  return {
    type: masterCourseID,
    payload: data,
  };
};

export const ClonedCourse = (data) => {
  return {
    type: isClonedCourse,
    payload: data,
  };
};

export const NominationEndDate = (data) => {
  return {
    type: Nomination_EndDate,
    payload: data,
  };
};

export const CourseStartDate = (data) => {
  return {
    type: courseStartDate,
    payload: data,
  };
};

export const ClassroomTimings = (data) => {
  return {
    type: classroomTimings,
    payload: data,
  };
};

export const CheckBoxGetPreviousBatchEmployees = (data) => {
  return {
    type: getPreviousBatchEmployees,
    payload: data,
  };
};

export const set_SelectedEmployees = (data) => {
  return {
    type: SET_SELECTED_EMPLOYEES,
    payload: data, // array of employee objects
  };
};

export const UserRoleAccess = (data) => {
  return {
    type: userRoleAccess,
    payload: data,
  };
};

export const LMSReqApprove = (data) => {
  return {
    type: lmsReqApprove,
    payload: data,
  };
};

export const ReassignCoordinator = (data) => {
  return {
    type: reassignCoordinator,
    payload: data,
  };
};

export const SuperAdminUserName = (data) => {
  return {
    type: superAdminUserName,
    payload: data,
  };
};

export const NominatedCourseID = (data) => {
  return {
    type: nominatedCourseID,
    payload: data,
  };
};

export const AllowEditClone = (data) => {
  return {
    type: iseditClonedCourse,
    payload: data,
  };
};
